import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

interface NotificationSkeletonProps {
    className?: string
    count?: number
}

const NotificationSkeleton: React.FC<NotificationSkeletonProps> = ({
    className = '',
    count = 3,
}) => {
    return (
        <div className={`space-y-3 ${className}`}>
            {Array.from({ length: count }).map((_, index) => (
                <div
                    key={index}
                    className="flex items-start gap-3 p-3 rounded-lg"
                >
                    {/* Avatar */}
                    <Skeleton className="w-[34px] h-[34px] rounded-full flex-shrink-0" />

                    {/* Content */}
                    <div className="flex-1 min-w-0 space-y-2">
                        {/* Title */}
                        <Skeleton className="h-4 w-3/4" />

                        {/* Description lines */}
                        <Skeleton className="h-3 w-full" />
                        <Skeleton className="h-3 w-5/6" />
                        <Skeleton className="h-3 w-2/3" />

                        {/* Attachment card (show for alternating items) */}
                        {index % 2 === 0 && (
                            <div className="mt-2 bg-muted/30 rounded-lg p-3 border">
                                <div className="flex items-center gap-3">
                                    <Skeleton className="w-10 h-12 flex-shrink-0" />
                                    <div className="flex-1 space-y-2">
                                        <Skeleton className="h-3 w-4/5" />
                                        <Skeleton className="h-3 w-2/5" />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Status indicator */}
                    <Skeleton className="w-2 h-2 rounded-full flex-shrink-0 mt-2" />
                </div>
            ))}
        </div>
    )
}

export default NotificationSkeleton
